<template>
  <section class="apply-qa">
    <template v-for="(i, index) in qaList">
      <div class="question" :class="index < qaList.length - 1 ? '':'no-border-bottom'" v-if="!i.judgeShow || !i.notShow(appChannel)" :key="index">
        <p class="title">
          <span class="question-icon"><span>问</span><i class="iconfont etc-icon-qa-circle" color-primary></i></span>
          <span class="title-content">{{i.question}}</span>
        </p>
        <p class="answer">
          <span class="question-icon"><span>答</span><i class="iconfont etc-icon-qa-circle" color-yellow></i></span>
          <span class="title-content">{{i.answer}}</span>
        </p>
      </div>
    </template>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// config
import ETC from '@/config/etc.config'

export default {
  name: 'applyQA',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      qaList: ETC.NEW_APPLY_QA
    }
  },
  methods: {},
  created() {
    window.scrollTo({
      left: 0,
      top: 0
    })
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.apply-qa{
  padding: 0 40px;
  .question{
    padding: 20px 40px 20px 0;
    border-bottom: 1px solid $border-bottom-color;
    .question-icon{
      width: 36px;
      height: 36px;
      position: relative;
      display: inline-block;
      line-height: 36px;
      text-align: center;
      margin-right: 20px;
      span{
        z-index: 2;
        position: relative;
        font-size: 22px;
        color: #FFFFFF;
      }
      i{
        position: absolute;
        font-size: 36px;
        top: 0;
        left: 0;
        z-index: 1;
      }
    }
    .title{
      .title-content{
        font-size: 26px;
        color: #333333;
      }
    }
    .answer{
      font-size: 26px;
      color: #999999;
      margin-top: 5px;
      @extend %flex-start;
      .question-icon{
        flex-basis: 36px;
        flex-shrink: 0;
      }
    }
  }
}
</style>
